<template>
    <v-container class="max-container">

        <v-row class="flex-col-start">
            <span class="item-line__title">Descontos para você</span>
            <v-col v-if="listDiscountInfoForYou.length > 0" cols="12" sm="12" md="12" lg="12" xl="12">
                
                <!--Mobile-->
                <div v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" class="carousel__div d-flex flex-auto flex-row">
                    <v-card
                      elevation="2"
                      class="product_card" 
                      v-for="(offer) in listDiscountInfoForYou" 
                      :key="offer.offerId"
                      @click="openProductsOffer(offer)"
                    >                        
                        <v-card-title class="no-pd div-img d-flex flex-auto align-center justify-center">
                            <v-img
                                :contain="offer.image"
                                :class="offer.image ? 'vrow_vcol_div_card_cadtext__img' : 'vrow_vcol_div_card_cadtext__img--default' "                            
                                :src="offer.image ? offer.image : imgDefault"
                            />                          
                        </v-card-title>
                        <v-card-text class="flex-col-center no-pd">
                            <v-col class="no-pd" cols="auto">
                                <div class="text-truncate">
                                    <span class="product_name">
                                     {{ offer.name}}
                                    </span>
                                </div>                                
                            </v-col>
                            <v-col  class="no-pd-b" cols="auto">
                                <span class="economy-offer">
                                    Entre {{offer.minDiscountPercent + "%"}} e {{offer.maxDiscountPercent + "%"}}
                                </span>
                            </v-col>
                            
                        </v-card-text>
                    </v-card>
                </div>

                <!--Desktop-->
                <v-slide-group
                    v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                    show-arrows
                    class="vcol__vslidegroup"
                >
                    <v-slide-item  v-for="(offer) in listDiscountInfoForYou" :key="offer.id">
                        <v-card 
                          elevation="2"
                          class="product_card" 
                          @click="openProductsOffer(offer)"
                        >                        
                            <v-card-title class="no-pd div-img d-flex flex-auto align-center justify-center">
                            <v-img
                                :contain="offer.image"
                                :class="offer.image ? 'vrow_vcol_div_card_cadtext__img' : 'vrow_vcol_div_card_cadtext__img--default' "                            
                                :src="offer.image ? offer.image : imgDefault"
                            />                          
                            </v-card-title>
                            <v-card-text class="flex-col-center no-pd">
                                <v-col class="no-pd" cols="auto">
                                    <div class="text-truncate">
                                        <span class="product_name">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <span v-on="on"> {{ offer.name}}</span>
                                                </template>
                                                 {{ offer.name}}
                                            </v-tooltip>
                                        </span>
                                    </div>                                
                                </v-col>
                                <v-col  class="no-pd-b" cols="auto">
                                    <span class="economy-offer">
                                        Entre {{offer.minDiscountPercent + "%"}} e {{offer.maxDiscountPercent + "%"}}
                                    </span>
                                </v-col>
                                
                            </v-card-text>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>                
            </v-col>
            <!--Empty-->
            <div v-else class="flex-col-center w-100" style="padding-top: 10px">
                <v-img class="div__emptyimg" src="@/assets/empty-views/empty_offers_1.svg"/>
            </div>
        </v-row>
 
        <v-row class="flex-col-start">
            <span class="item-line__title">Em destaque</span>
            
            <v-col v-if="listHighlightedInfo.length > 0" cols="12" sm="12" md="12" lg="12" xl="12">
                
                <!--Mobile-->
                <div v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" class="carousel__div d-flex flex-auto flex-row">
                    <v-card
                        elevation="2"
                        class="product_card" 
                        v-for="(offer) in listHighlightedInfo" 
                        :key="offer.offerId"
                        @click="openProductsOffer(offer)"
                    >                        
                        <v-card-title class="no-pd div-img d-flex flex-auto align-center justify-center">
                            <v-img
                                :contain="offer.image"
                                :class="offer.image ? 'vrow_vcol_div_card_cadtext__img' : 'vrow_vcol_div_card_cadtext__img--default' "                            
                                :src="offer.image ? offer.image : imgDefault"
                            />                          
                        </v-card-title>
                        <v-card-text class="flex-col-center no-pd">
                            <v-col class="no-pd" cols="auto">
                                <div class="text-truncate">
                                    <span class="product_name">
                                     {{ offer.name}}
                                    </span>
                                </div>                                
                            </v-col>
                            <v-col  class="no-pd-b" cols="auto">
                                <span class="economy-offer">
                                    Entre {{offer.minDiscountPercent + "%"}} e {{offer.maxDiscountPercent + "%"}}
                                </span>
                            </v-col>
                            
                        </v-card-text>
                    </v-card>
                </div>

                <!--Desktop-->
                <v-slide-group
                    v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                    show-arrows
                    class="vcol__vslidegroup"
                >
                    <v-slide-item v-for="(offer) in listHighlightedInfo" :key="offer.offerId">
                        <v-card
                            elevation="2"
                            class="product_card" 
                            @click="openProductsOffer(offer)"
                        >                        
                            <v-card-title class="no-pd div-img d-flex flex-auto align-center justify-center">
                            <v-img
                                :contain="offer.image"
                                :class="offer.image ? 'vrow_vcol_div_card_cadtext__img' : 'vrow_vcol_div_card_cadtext__img--default' "                            
                                :src="offer.image ? offer.image : imgDefault"
                            />                          
                            </v-card-title>
                            <v-card-text class="flex-col-center no-pd">
                                <v-col class="no-pd" cols="auto">
                                    <div class="text-truncate">
                                        <span class="product_name">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <span v-on="on"> {{ offer.name}}</span>
                                                </template>
                                                 {{ offer.name}}
                                            </v-tooltip>
                                        </span>
                                    </div>                                
                                </v-col>
                                <v-col  class="no-pd-b" cols="auto">
                                    <span class="economy-offer">
                                        Entre {{offer.minDiscountPercent + "%"}} e {{offer.maxDiscountPercent + "%"}}
                                    </span>
                                </v-col>
                                
                            </v-card-text>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>                
            </v-col>

            <!--Empty-->
            <div v-else class="flex-col-center w-100" style="padding-top: 10px">
                <v-img class="div__emptyimg" src="@/assets/empty-views/empty_offers_2.svg"/>
            </div>
        </v-row>
        <offerRedeems 
            :dialog="offerRedeemsModal"
            :offerTitle="offerTitleLocal"
            :localOfferId="offerId"
            @closeOfferRedeemstModal="closeOfferRedeemstModal()"
        /> 
    </v-container>
</template> 

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getGeneralOffersByCompanyIdAndCurrentContactId, getExclusiveOffersByCompanyIdAndCurrentContactId } from "@/app/components/offers/service/offers.service"

//Components
import offerRedeems from "@/app/modals/offer-redeems-modal/offer-redeems-modal";

export default {
    name: "Offers",
    components: { offerRedeems },
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany'
        })
    },
    data: ()=> ({
        listDiscountInfoForYou: [],
        offerRedeemsModal: false,
        offerTitleLocal: null,
        offerId: null,
        listHighlightedInfo: [],
        imgDefault: require('@/assets/empty_ofertas.svg')
    }),
    created(){
        this.getAllScreenInfo()
    },
    methods: {
        goToOfferDetail(id){
            this.$router.push({path: `/detalheOferta?offerId=${id}`})
        },
        getAllScreenInfo(){
            this.getInformationDiscountsForYou()
            this.getInformingHighlighted()
            
        },
        getInformationDiscountsForYou() {
            getExclusiveOffersByCompanyIdAndCurrentContactId(this.currentCompany.id, true)
            .then( success => {
                this.listDiscountInfoForYou = success.data
            })
            .catch( error => error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '')
        },
        getInformingHighlighted() {
            getGeneralOffersByCompanyIdAndCurrentContactId(this.currentCompany.id,  true)
            .then( success => {
                this.listHighlightedInfo = success.data
            })
            .catch( error => error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '')
        },        
        openProductsOffer(offer){
            this.offerId = offer.offerId;
            this.offerTitleLocal = offer.name;
            this.offerRedeemsModal = true;        
        },
        closeOfferRedeemstModal() {
            this.offerRedeemsModal = false;
        }        
    }
}
</script>

<style scoped>
::v-deep .v-slide-group__prev {
    min-width: 10px;
    padding-right: 6px;
    color: var(--cor--preta) !important;
}
::v-deep .v-slide-group__next {
    min-width: 10px;
    padding-left: 6px;
    color: var(--cor--preta) !important;
}
.vcol__vslidegroup {
    padding-top: 12px;
    height: 282px;
    padding: 6px;
}

.current-price{
    font-weight: 600;
    font-size: 16px;
    color: var(--cor--verde);
    margin-left: 5px;
}
.item-line__title{
    font-weight: 700;
    font-size: 20px;
}
.carousel__div{
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 282px;
    padding: 6px;
}
.vrow_vcol_div_card_cadtext__img{
    max-width: 100%;
    height: 112px;
    border-top-right-radius: 6px !important;
    border-top-left-radius: 6px !important;
}
.vrow_vcol_div_card_cadtext__img--default {
    min-width: 130px;
    max-width: 150px;
}
.product_card {
    max-width: 200px !important;
    min-width: 200px !important;    
    height: 236px;
    margin: 2px 15px 6px 1px;
    border-radius: 6px !important;
}
.discount_brand{
    background-color: orange;
    width: 100%;
    margin-top: 0.;
}
.product_name{
    color: var(--cor--preta);
    font-size: 15px;
    padding: 5px;
    text-align: center;
    max-width: 100%;
}
.product-action-btn{
    position: relative;
    top: 21px;
}
.div__emptyimg {
    width: 250px;
}
.div-img {
    width: 100%;
    margin-bottom: 16px;
}
.economy-offer{
    font-size: 12px;
    color: gray;
}
</style>